"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _mergeInputFieldEventHandlers = require("../mergeInputField.eventHandlers.helper");
var _mergeInputField = require("../mergeInputField.helper");
var _mergeInputField2 = require("../mergeInputField.data");
var _input = _interopRequireDefault(require("./input.presenter"));
var _iconContainer = _interopRequireDefault(require("../iconContainer/iconContainer.presenter"));
var _mergeInputField3 = require("../mergeInputField.shapes");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var stringType = _mergeInputField2.dataTypes.stringType;
var InputContainer = function InputContainer(props) {
  var selectedItem = props.selectedItem,
    locale = props.locale,
    uniqueID = props.uniqueID,
    value = props.value,
    placeholder = props.placeholder,
    types = props.types,
    validation = props.validation,
    onDropdownVisible = props.onDropdownVisible,
    isReadOnly = props.isReadOnly,
    hasMultipleLines = props.hasMultipleLines,
    isDisabled = props.isDisabled,
    highlightedItem = props.highlightedItem,
    results = props.results,
    areResultsVisible = props.areResultsVisible,
    isPromotionSelected = props.isPromotionSelected,
    isLookupSelected = props.isLookupSelected,
    isLookupFieldSelected = props.isLookupFieldSelected,
    setReference = props.setReference,
    isSomethingSelected = props.isSomethingSelected;
  var isMergingAllowed = types.includes(stringType);
  var validationResults = (0, _mergeInputField.findFailedValidation)({
    validation: validation,
    value: value
  });
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('inputContainer', {
      readOnly: isReadOnly,
      disabled: isDisabled
    }),
    "data-testid": "inputContainer"
  }, (0, _mergeInputField.hasActualSelectionType)({
    isSomethingSelected: isSomethingSelected,
    isPromotionSelected: isPromotionSelected,
    isLookupSelected: isLookupSelected
  }) && _react.default.createElement(_iconContainer.default, {
    sourceType: selectedItem.sourceType,
    locale: locale
  }), (0, _mergeInputField.hasPossibleSelectionType)({
    isSomethingSelected: isSomethingSelected,
    isPromotionSelected: isPromotionSelected,
    isLookupSelected: isLookupSelected,
    types: types
  }) && _react.default.createElement(_iconContainer.default, {
    sourceType: types[0],
    locale: locale,
    hasSuggestion: validationResults !== undefined || !value
  }), _react.default.createElement(_input.default, {
    value: value,
    placeholder: placeholder,
    id: uniqueID,
    className: (0, _classnames.default)('inputElement', {
      invalid: validationResults
    }),
    readOnly: isReadOnly,
    hasMultipleLines: hasMultipleLines,
    onChange: function onChange(event) {
      return (0, _mergeInputFieldEventHandlers.onChangeHandler)(event, _objectSpread({}, props, {
        isPromotionSelected: isPromotionSelected,
        isLookupSelected: isLookupSelected,
        isLookupFieldSelected: isLookupFieldSelected,
        isMergingAllowed: isMergingAllowed
      }))(uniqueID);
    },
    onKeyDown: function onKeyDown(event) {
      return (0, _mergeInputFieldEventHandlers.onKeyDownHandler)(event, _objectSpread({}, props, {
        areResultsVisible: areResultsVisible,
        results: results,
        highlightedItem: highlightedItem,
        isMergingAllowed: isMergingAllowed,
        types: types
      }))(uniqueID);
    },
    onKeyUp: function onKeyUp(event) {
      return (0, _mergeInputFieldEventHandlers.onKeyUpHandler)(event, _objectSpread({}, props, {
        isPromotionSelected: isPromotionSelected,
        isLookupSelected: isLookupSelected,
        isLookupFieldSelected: isLookupFieldSelected,
        isMergingAllowed: isMergingAllowed
      }))(uniqueID);
    },
    onClick: function onClick(event) {
      return (0, _mergeInputFieldEventHandlers.onInputClickHandler)(event, _objectSpread({}, props, {
        isPromotionSelected: isPromotionSelected,
        isLookupSelected: isLookupSelected,
        isLookupFieldSelected: isLookupFieldSelected,
        isMergingAllowed: isMergingAllowed
      }))(uniqueID);
    },
    onFocus: function onFocus() {
      return onDropdownVisible(uniqueID, true);
    },
    onBlur: function onBlur() {
      return onDropdownVisible(uniqueID, false);
    },
    setReference: setReference,
    disabled: isDisabled
  }), _react.default.createElement("div", {
    className: "animatedBorder"
  }));
};
InputContainer.propTypes = {
  value: _propTypes.string.isRequired,
  uniqueID: _propTypes.string.isRequired,
  setReference: _propTypes.func.isRequired,
  onDropdownVisible: _propTypes.func.isRequired,
  types: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  validation: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    criteria: _propTypes.func.isRequired,
    message: _propTypes.string.isRequired
  })),
  placeholder: _propTypes.string,
  highlightedItem: _mergeInputField3.dataShape,
  isReadOnly: _propTypes.bool,
  hasMultipleLines: _propTypes.bool,
  isDisabled: _propTypes.bool,
  areResultsVisible: _propTypes.bool,
  results: (0, _propTypes.arrayOf)(_mergeInputField3.dataShape),
  isPromotionSelected: _propTypes.bool,
  isLookupSelected: _propTypes.bool,
  isLookupFieldSelected: _propTypes.bool,
  isSomethingSelected: _propTypes.bool,
  selectedItem: (0, _propTypes.shape)({
    sourceType: _propTypes.string.isRequired
  }),
  locale: _mergeInputField3.localeShape.isRequired
};
var _default = InputContainer;
exports.default = _default;